import { render, staticRenderFns } from "./RoomsCreateModal.vue?vue&type=template&id=08e463b0&scoped=true&"
import script from "./RoomsCreateModal.vue?vue&type=script&lang=js&"
export * from "./RoomsCreateModal.vue?vue&type=script&lang=js&"
import style0 from "./RoomsCreateModal.vue?vue&type=style&index=0&id=08e463b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e463b0",
  null
  
)

export default component.exports